<h1>{{topic.name}}</h1>
<h3><a href="{{course.url}}">{{course.name}}</a></h3>

<ul>
  <li *ngFor="let iol of topic.iols"><a href="{{iol.url}}">{{iol.name}}</a></li>
</ul>

<h3>Notes</h3>
<app-notes [notes]="topic.notes"></app-notes>
